import Vue from 'vue'
import Router from 'vue-router'
import routes from './routes'
import store from '@/xreports/store/index'
import storeCEM from '@/hotelcem/store/index'
import apiUtils from '@/hotelcem/apis/api-utils'
import { RouterService } from 'voc-service'
import StatisticsService from '../apis/hotel-statistics/StatisticsService'

Vue.use(Router)

// 覆盖原型方法
const originRouterPush = Router.prototype.push
Router.prototype.push = function (location, onComplete, onAbort) {
  this._nativeHistoryState = Number(history.state?.key)
  return originRouterPush.call(this, location, onComplete, onAbort).catch(err => err)
}
Router.prototype.go = function (n) {
  this.isBack = n < 0
  this.history.go(n)
  setTimeout(() => {
    this.isBack = false
  }, 300)
}
//处理浏览器回退事件
window.addEventListener('popstate', e => {
  //只处理用户点击浏览器回退动作，真实回退行为交给back
  let historyState = Number(e?.state?.key)
  //如果没有浏览器的上次historyState信息，不能执行浏览器forward，当back处理
  //当前historyState小于上次，当back处理
  router.isBack = !router._nativeHistoryState || historyState <= router._nativeHistoryState

  router._nativeHistoryState = historyState
  setTimeout(() => {
    router.isBack = false
  }, 300)
})

const router = new Router({
  mode: 'history',
  base: process.env.VUE_APP_HOTEL_CEM_ROUTER_BASE,
  scrollBehavior: () => ({ y: 0 }),
  routes,
})
const routerService = new RouterService()

async function checkAuthority(next, path) {
  try {
    console.log('checkLogin!!!')
    await store.dispatch('systemUser/checkLogin')
    const deviceMode = storeCEM.getters.deviceMode
    const param =
      deviceMode === 'mobile'
        ? {
            menuVersion: 1,
          }
        : {}
    await storeCEM.dispatch('menus/initMenuList', param)

    // 验证完登录以后替换掉 url 上的 ticket 防止重复使用
    next(path.replace('ticket=', 'void='))
    setTimeout(() => {
      document.documentElement.scrollTop = 0
      document.body.scrollTop = 0
    }, 0)
  } catch (error) {
    console.error(error)
    store.dispatch('systemUser/logout')
  }
}

router.beforeEach((to, from, next) => {
  // if (to.query.hideNav === '1' && ['HOTEL-CEM-HOME', 'HOTEL-CEM-HOME-CEM'].includes(to.name)) {
  if (to.query.hideNav === '1') {
    storeCEM.commit('common/setHideChildMenu', true)
  }
  // 如果移动端菜单开启着 关闭一下
  document.querySelector('.voc-header-menu__drawer .el-icon-close') &&
    document.querySelector('.voc-header-menu__drawer .el-icon-close').click()

  apiUtils.init(to, from)
  // 目前只处理国际化

  routerService.beforeEach({ to, Vue })
  // 百度统计,window._hmt仅在PROD环境中存在

  let path = to.matched?.length ? to.matched[to.matched.length - 1].path : to.path
  if (window._hmt) {
    if (path) {
      window._hmt.push(['_trackPageview', router.options.base + path])
    }
  }
  // 增加自定义上报统计
  const excludeList = ['WARNING-SYSTEM-WARNING-RECORD-DETAIL', 'WARNING-SYSTEM-WARNING-RECORD-DETAIL-NORMAL']

  setTimeout(() => {
    if (storeCEM.getters.hotelInfo?.hotelId && to.name && !excludeList.includes(to.name)) {
      StatisticsService.hotelPV({
        pageUrl: router.options.base + path,
        hotelId: storeCEM.state.common.dateFilter.hotelInfo?.hotelInfo?.hotelId,
        pc: storeCEM.getters.deviceMode !== 'mobile' ? 1 : 0,
        h5: storeCEM.getters.deviceMode === 'mobile' ? 1 : 0,
      })
    }
  }, 2000) //storeCEM.getters.hotelInfo?.hotelId 延时，上报可稍微延迟触发

  // 菜单已经初始化
  if (storeCEM.state.menus.initialized) {
    next()
    return
  }
  // 权限验证
  checkAuthority(next, to.fullPath)
})

export default router
